<div class="edit-media" [style.visibility]="visibility">
  <div class="header">
    <div class="header-title">{{ 'dynamicContent.editMedia' | translate }}</div>
  </div>
  <div class="edit-format">
    <div class="formats">
      <div (click)="openFormat('original')" class="format"
           [ngClass]="{active: activeFormat === 'original'}">{{ 'resources.imageFormat.original' | translate }}
      </div>
      <div *ngIf="showOneToOne" (click)="openFormat('oneToOne')" class="format"
           [ngClass]="{active: activeFormat === 'oneToOne'}">{{ 'resources.imageFormat.oneToOne' | translate }}
      </div>
      <div *ngIf="showSixteenToNine" (click)="openFormat('sixteenToNine')" class="format"
           [ngClass]="{active: activeFormat === 'sixteenToNine'}">{{ 'resources.imageFormat.sixteenToNine' | translate }}
      </div>
      <div *ngIf="showWidget" (click)="openFormat('widgetSize')" class="format"
           [ngClass]="{active: activeFormat === 'widgetSize'}">{{ 'resources.imageFormat.widgetSize' | translate }}
      </div>
      <div *ngIf="showFourToThree" (click)="openFormat('fourToThree')" class="format"
           [ngClass]="{active: activeFormat === 'fourToThree'}">{{ 'resources.imageFormat.fourToThree' | translate }}
      </div>
      <div *ngIf="showFreeForm" (click)="openFormat('freeForm')" class="format"
           [ngClass]="{active: activeFormat === 'freeForm'}">{{ 'resources.imageFormat.freeForm' | translate }}
      </div>
    </div>
    <div class="image-info-container">
      <div *ngIf="!edit" class="image-preview-container"></div>
      <image-editor-v2 *ngIf="edit" (imageEditorSave)="onImageEditorChange($event)" [clip]="get(activeFormat, 'clip')"
                       [data]="get(activeFormat, 'data')" [rawHeight]="boundImageAsset.rawHeight" [type]="activeFormat"
                       [rawImagePath]="imageAssetPath + boundImageAsset.path + '/' + 'raw'" [rawWidth]="boundImageAsset.rawWidth"
                       #imageEditor></image-editor-v2>
      <div *ngIf="boundImageAsset" class="image-info">
        <div class="image-info-row"><b>{{ 'resources.title' | translate }}:</b><span>{{ boundImageAsset?.title }}</span></div>
        <div class="image-info-row"><b>{{ 'resources.fileName' | translate }}:</b><span>{{ boundImageAsset?.originalFileName }}</span></div>
        <div class="image-info-row">
          <b>{{ 'resources.isInContent' | translate }}:</b>
          <span>{{ isInContent ? ('resources.yes' | translate) : ('resources.no' | translate) }}</span>
        </div>
        <div class="image-info-row">
          <b>{{ 'resources.size' | translate }}:</b>
          <span *ngIf="activeFormat !== 'original'">{{ boundImageAsset?.resizeInformation[activeFormat]?.fileSize | fileSize }}</span>
          <span *ngIf="activeFormat === 'original'">{{ boundImageAsset?.fileSize | fileSize }}</span>
        </div>
        <div class="image-info-row">
          <b>{{ 'resources.dimension' | translate }}:</b>
          <span *ngIf="activeFormat !== 'original'">{{ boundImageAsset?.resizeInformation[activeFormat]?.clip?.width }}x{{ boundImageAsset?.resizeInformation[activeFormat]?.clip?.height }}</span>
          <span *ngIf="activeFormat === 'original'">{{ boundImageAsset?.rawWidth }}x{{ boundImageAsset?.rawHeight }}</span>
        </div>
        <div class="image-info-row">
          <b>{{ 'resources.uploadDate' | translate }}:</b><span>{{ boundImageAsset?.created | date: 'dd.MM.yyyy' }}</span>
        </div>
      </div>
    </div>
    <div class="edit-title" *ngIf="activeFormat === 'original'">
      <title-translate [asset]="data.asset" [languages]="data.availableLanguages" [packageLang]="data.packageLang" [showSave]="false"
                       [selectedLanguages]="data.asset.translatedTitles" [showInFrontCheckbox]="true"
                       (changed)="titleUpdate()"></title-translate>
    </div>
  </div>
  <div class="button-container">
    <button (click)="cancelChanges()" class="ibexfusion-raised-button" mat-button>{{ 'general.cancel' | translate }}</button>
    <button (click)="onImageEditorSave(newImageData)" class="ibexfusion-raised-button" [disabled]="!newImageData && !titleUpdated"
            [class.mat-button-disabled]="!newImageData && !titleUpdated" mat-button>{{ 'general.save' | translate }}
    </button>
  </div>
</div>
